<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


const testominialVideo = document.getElementById("testimonial-video")

const clickHandler =  (event) => {
  console.log("clicked")
    testominialVideo.play()
    testominialVideo.removeEventListener( 'click', clickHandler, false)	
};

testominialVideo.addEventListener( 'click', clickHandler, false)
